var xs = '2px';
var sm = '4px';
var md = '6px';
var lg = '8px';
var xl = '12px';
var xxl = '16px';
var none = '0px';
var round = '50%';
var def = md;

var borderRadiuses = /*#__PURE__*/Object.freeze({
	__proto__: null,
	xs: xs,
	sm: sm,
	md: md,
	lg: lg,
	xl: xl,
	xxl: xxl,
	none: none,
	round: round,
	def: def
});

var yellow = {
  25: '#EDDDBF',
  50: '#FFFAE5',
  100: '#F7C56E',
  500: '#FFD000',
  700: '#7B664C',
  800: '#3A352C'
};
var red = {
  100: '#FF7C6B',
  500: '#D93311'
};
var green = {
  100: '#77Cf9D',
  500: '#268750'
};
var ruby = {
  100: '#FA6681',
  500: '#E30D34'
};
var accent = '#2000F0';
var webkitOutline = '#3B99FC';
var grayscale = {
  0: '#FFFFFF',
  15: '#F6F6F7',
  25: '#F0F0F0',
  50: '#F8F8F8',
  75: '#EDEDED',
  100: '#E3E3E3',
  200: '#D5D5D5',
  300: '#C0C0C0',
  400: '#B3B3B3',
  425: '#A6A4A4',
  450: '#949494',
  500: '#757575',
  525: '#707070',
  550: '#6E6E6E',
  600: '#575757',
  625: '#474747',
  650: '#333333',
  700: '#2E2E2E',
  800: '#252525',
  900: '#111111'
};
var brand = {
  orange: '#FF5100',
  black: '#1B1B20'
};

var colorPalette = /*#__PURE__*/Object.freeze({
	__proto__: null,
	yellow: yellow,
	red: red,
	green: green,
	ruby: ruby,
	accent: accent,
	webkitOutline: webkitOutline,
	grayscale: grayscale,
	brand: brand
});

var subtle = 'rgba(0, 0, 0, 0.125) 0px 0.362176px 0.941657px -1px, rgba(0, 0, 0, 0.18) 0px 3px 7.8px -2px';
var xs$1 = "0px 0.6px 0.54px -1.33px rgba(0, 0, 0, 0.15), 0px 2.29px 2.06px -2.67px rgba(0, 0, 0, 0.13), 0px 10px 9px -4px rgba(0, 0, 0, 0.04);";
var sm$1 = "0px 0.48px 2.22px -1.17px rgba(0, 0, 0, 0.14), 0px 1.83px 8.42px -2.33px rgba(0, 0, 0, 0.12), 0px 8px 36.8px -3.5px rgba(0, 0, 0, 0.06);";
var floating = "0px 0.48px 2.41px -0.38px rgba(0, 0, 0, 0.05), 0px 4px 20px -0.75px rgba(0, 0, 0, 0.17)";
var md$1 = floating;
var lg$1 = floating;
var xl$1 = "rgba(0, 0, 0, 0.075) 0px 0.602187px 2.04744px -1.33333px, rgba(0, 0, 0, 0.067) 0px 2.28853px 7.78101px -2.66667px, rgba(0, 0, 0, 0.02) 0px 10px 34px -4px";
var enormous = "rgba(0, 0, 0, 0.035) 0px 0.796192px 3.98096px -0.1875px, rgba(0, 0, 0, 0.047) 0px 2.41451px 12.0725px -0.375px, rgba(0, 0, 0, 0.075) 0px 6.38265px 31.9133px -0.5625px, rgba(0, 0, 0, 0.17) 0px 20px 100px -0.75px;";
var outline = "0 0 0 1px " + accent;

var boxShadows = /*#__PURE__*/Object.freeze({
	__proto__: null,
	subtle: subtle,
	xs: xs$1,
	sm: sm$1,
	floating: floating,
	md: md$1,
	lg: lg$1,
	xl: xl$1,
	enormous: enormous,
	outline: outline
});

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

var light = _extends({}, colorPalette, {
  border: grayscale[500],
  borderSubtle: grayscale[100],
  divider: grayscale[100],
  error: red[500],
  errorContrast: grayscale[0],
  subtleFeedback: yellow[50],
  subtleFeedbackContrast: grayscale[900],
  caution: '#FFAE21',
  cautionDimmed: '#FFF3D6',
  cautionContrast: grayscale[900],
  cautionDesaturated: yellow[25],
  success: green[500],
  successContrast: grayscale[0],
  primaryTextColor: grayscale[900],
  secondaryTextColor: grayscale[550],
  tertiaryTextColor: grayscale[400],
  surface: grayscale[0],
  surfaceVariant: grayscale[25],
  surfaceVariantHover: '#E6E6E6',
  surfaceInteractive: grayscale[50],
  surfaceInteractivePressed: grayscale[600],
  surfaceDecorative: grayscale[100],
  surfaceDimmed: '#E6E4E1',
  surfaceFade: grayscale[15],
  hintSurface: grayscale[800],
  floatSurface: grayscale[0],
  pressedElement: grayscale[300],
  notification: ruby[500],
  notificationContrast: grayscale[0],
  widgetBackground: grayscale[50],
  disabled: grayscale[100],
  disabledContrast: grayscale[600],
  inactiveElement: grayscale[450],
  formIconColor: grayscale[50],
  trademarkFooterText: grayscale[600],
  itemHover: grayscale[625],
  successHover: '#2FA763',
  inactiveElementHover: grayscale[425],
  secondaryButtonBackground: grayscale[100],
  secondaryButtonBackgroundHover: grayscale[200],
  primaryTimelineSurface: grayscale[0],
  decorations: {
    decorOne: '#FFDAB9',
    decorTwo: '#D9CCFA',
    decorThree: '#FACCCC',
    decorFour: '#F4F791',
    decorFive: '#F1C9FC'
  }
});
var dark = _extends({}, colorPalette, {
  border: grayscale[600],
  borderSubtle: grayscale[650],
  divider: grayscale[700],
  error: red[100],
  errorContrast: grayscale[900],
  subtleFeedback: yellow[800],
  subtleFeedbackContrast: yellow[100],
  caution: yellow[100],
  cautionDimmed: '#322B24',
  cautionContrast: grayscale[900],
  cautionDesaturated: yellow[700],
  success: green[100],
  successContrast: grayscale[900],
  primaryTextColor: grayscale[0],
  secondaryTextColor: grayscale[400],
  tertiaryTextColor: grayscale[600],
  surface: grayscale[800],
  surfaceVariant: grayscale[700],
  surfaceVariantHover: '#333333',
  surfaceInteractive: grayscale[700],
  surfaceInteractivePressed: grayscale[400],
  surfaceDecorative: grayscale[700],
  surfaceDimmed: '#1F1E1D',
  surfaceFade: grayscale[700],
  hintSurface: grayscale[550],
  floatSurface: grayscale[700],
  pressedElement: grayscale[600],
  notification: ruby[100],
  notificationContrast: grayscale[900],
  widgetBackground: grayscale[900],
  disabled: grayscale[700],
  disabledContrast: grayscale[400],
  inactiveElement: grayscale[600],
  formIconColor: grayscale[900],
  trademarkFooterText: grayscale[400],
  itemHover: grayscale[525],
  successHover: '#99DBB5',
  inactiveElementHover: grayscale[800],
  secondaryButtonBackground: grayscale[650],
  secondaryButtonBackgroundHover: grayscale[625],
  primaryTimelineSurface: grayscale[800],
  decorations: {
    decorOne: '#D7650F',
    decorTwo: '#400CC6',
    decorThree: '#AF3C3C',
    decorFour: '#ACB125',
    decorFive: '#831AA2'
  }
});

var colors = /*#__PURE__*/Object.freeze({
	__proto__: null,
	light: light,
	dark: dark
});

var ROOT_FONT_SIZE = 16;
var pxToRem = function pxToRem(px) {
  return px / ROOT_FONT_SIZE + "rem";
};

var size18 = pxToRem(18);
var size16 = pxToRem(16);
var size14 = pxToRem(14);
var size12 = pxToRem(12);

var fontSizes = /*#__PURE__*/Object.freeze({
	__proto__: null,
	size18: size18,
	size16: size16,
	size14: size14,
	size12: size12
});

var space0 = '0px';
var space1 = '2px';
var space2 = '4px';
var space3 = '8px';
var space4 = '10px';
var space5 = '12px';
var space6 = '16px';
var space7 = '24px';

var spaces = /*#__PURE__*/Object.freeze({
	__proto__: null,
	space0: space0,
	space1: space1,
	space2: space2,
	space3: space3,
	space4: space4,
	space5: space5,
	space6: space6,
	space7: space7
});

var easings = {
  easeOutStrong: 'cubic-bezier(0.25, 1, 0.5, 1)',
  linear: 'cubic-bezier(0, 0, 1, 1)',
  sharp: 'cubic-bezier(0.33, 0, 0, 1)',
  smooth: 'cubic-bezier(0.33, 0, 0.67, 1)',
  swift: 'cubic-bezier(0.14, 0, 0, 1)',
  spring: 'cubic-bezier(0.18, 0.89, 0.32, 1.28)'
};

var transitions = /*#__PURE__*/Object.freeze({
	__proto__: null,
	easings: easings
});

var heading = {
  fontSize: size16,
  fontWeight: 'bold'
};
var subheading = {
  fontSize: size14,
  fontWeight: 'bold'
};
var input = {
  fontSize: size14,
  fontWeight: 'normal'
};
var placeholder = {
  fontSize: size14,
  fontWeight: 'normal'
};
var caption = {
  fontSize: size12,
  fontWeight: 'normal'
};
var basic = {
  fontSize: size14,
  fontWeight: 'normal'
};
var basicContrast = {
  fontSize: size14,
  fontWeight: 'normal'
};
var errorCaption = {
  fontSize: size12,
  fontWeight: 'normal'
};
var heroHeader = {
  fontSize: size18,
  fontWeight: 'bold'
};
var code = {
  fontFamily: 'monospace !important',
  fontSize: '13px',
  fontWeight: 'normal'
};
var buttonText = {
  fontSize: size14,
  fontWeight: 'bold'
};

var typography = /*#__PURE__*/Object.freeze({
	__proto__: null,
	heading: heading,
	subheading: subheading,
	input: input,
	placeholder: placeholder,
	caption: caption,
	basic: basic,
	basicContrast: basicContrast,
	errorCaption: errorCaption,
	heroHeader: heroHeader,
	code: code,
	buttonText: buttonText
});

export { borderRadiuses, boxShadows, colorPalette, colors, fontSizes, pxToRem, spaces, transitions, typography };
